import { StringUtils } from '@pk/powerkioskutils';

import moment from 'moment-timezone';

import { getSupplierDashboardSessionStatus, SupplierDashboardTimeRemaining } from './supplier-dashboard-session-status';

export class SupplierDashboardBiddingSession {
	public rfqSessionId: string;
	public rfqSessionSupplierId: string;
	public startDate: Date;
	public endDate: Date;
	public effectiveEndDate: string;
	public formattedStartDate: string;
	public formattedEndDate: string;
	public displayAnnualUsage: number;
	public displayAnnualUsageUnits: string;
	public units: string;
	public contractNum: string;
	public contractStatus: string;
	public dbaName: string;
	public utilityAccountNumList: string | string[];
	public utilityNameList: string | string[];
	public loaHasEsignList: string | boolean[];
	public serviceTypeId: string;
	public serviceTypeName: string;
	public isOptOut: boolean;
	public locationCount: number;
	public rfqSessionStatus: string;
	public numParticipants: number;
	public isPinned: boolean;
	public lifeTimeBids: number;
	public isOpenToBid: boolean;
	public didParticipate: boolean;

	public optInText = 'Opt Back In';
	public optInDisabled = false;

	public timeRemaining: SupplierDashboardTimeRemaining;
	public timeRemainingDisplay: string;
	public rfqSessionStatusColor: string;

	constructor(biddingSession: SupplierDashboardBiddingSession) {
		Object.assign(this, biddingSession);

		this.startDate = this.startDate ? new Date(moment(this.startDate).format('MMM DD, YYYY hh:mm:ss a')) : this.startDate;
		this.endDate = this.endDate ? new Date(moment(this.endDate).format('MMM DD, YYYY hh:mm:ss a')) : this.endDate;
		this.utilityNameList = this.utilityNameList ? (this.utilityNameList as string).split(',') : [];
		this.utilityAccountNumList = this.utilityAccountNumList ? (this.utilityAccountNumList as string).split(',') : [];
		this.loaHasEsignList = this.loaHasEsignList ? (this.loaHasEsignList as string).split(',').map(e => StringUtils.toBoolean(e)) : [];

		this.setupSessionStatus();

		// as long as we're not completed, update every second
		if (this.timeRemainingDisplay !== '0d 0h 0m') {
			const interval = setInterval(() => {
				this.setupSessionStatus();
				if (this.timeRemainingDisplay === '0d 0h 0m') {
					clearInterval(interval);
				}
			}, 1000);
		}
	}

	get loaAvailable(): boolean {
		return typeof this.loaHasEsignList === 'object' && (this.loaHasEsignList as boolean[]).includes(true);
	}

	private setupSessionStatus(): void {
		Object.assign(this, getSupplierDashboardSessionStatus(this));
	}
}
